import React from "react";
import DisclosureCore from "../../../utils/disclosure/DisclosureCore";
import H3 from "../../../elements/titles/H3";
import Paragraph from "../../../elements/p/Paragraph";
import Container from "../../../utils/Container";

const SomeAdvices = () => {
  return (
    <Container classe="mt-3">
      <DisclosureCore title="Quelsques conseils très importants">
        <H3>Quelsques conseils très importants</H3>
        <Paragraph>
          Vous n'êtes pas obligé de respecter des conseils si dessous et votre
          site continura de fonctionner. Mais pour une utilisation plus
          optimale, je vous conseille de respecter les conseils ci-dessous.
        </Paragraph>

        <ul className="mt-4 flex flex-col space-y-4">
          <li>
            <H3>
              1. Ne pas avoir moins de 3 catégories de produits dans la boutique
            </H3>
            <Paragraph>
              {" "}
              Le site s'adaptera même si vous n'avez qu'une seule catégorie de
              produits mais pour une expérience utilisateur plus cool je vous
              invite à avoir au moins 3 catégories.
            </Paragraph>
          </li>
          <li>
            <H3>2. Toujours supprimer tous ce qui n'est pas important</H3>
            <Paragraph>
              Si vous avez un produit sur le site que vous ne commercialisez
              plus, supprimez-le! Si vous avez une catégorie dont aucun produit
              n'est associé, supprimez-la ! Si dans la liste des utilisateur non
              contacté de votre interface d'admin il y a un utilisateur que vous
              ne trouvez pas important, supprimez-le !
            </Paragraph>
            <Paragraph>
              En supprimant toutes ces données non-importantes, vous allez
              libérer de l'espace dans votre site ce qui le rendra plus rapide
              et performant.
            </Paragraph>
          </li>
        </ul>
      </DisclosureCore>
    </Container>
  );
};

export default SomeAdvices;
